<template>
  <v-container class="py-12">
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">Emplois Vacants</h1>

      <div class="subtitle-1 text--secondary mt-2">
        Sélectionnez une catégorie, parcourez nos emplois vacants et postulez-y
      </div>

      <v-btn-toggle
        class="mt-6"
        v-model="jobType"
        mandatory
        color="primary"
      >
        <v-btn value="ENS">
          Enseignement
        </v-btn>

        <v-btn value="ADM">
          Administratif
        </v-btn>
      </v-btn-toggle>
    </div>

    <jobs-table :jobType="jobType"></jobs-table>
  </v-container>
</template>

<script>
import JobsTable from '@/components/vacant-jobs/JobsTable.vue';

export default {
  name: 'VacantJobs',

  components: {
    'jobs-table': JobsTable,
  },

  data: () => ({
    jobType: 'ENS',
  }),
};
</script>
